module.exports = __webpack_public_path__ + "img/coinspopup-1.b47a5f58.png";